export default __webpack_public_path__ + "static/media/aloe_capital_logo_holo.1889a986.svg";